import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'hitech-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'HiTech Health Solutions',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 205-447-2764,
  email: 'support@hitechhealthsolutions.com',
  poweredByLogo: false,
};

export default config;


// WEBPACK FOOTER //
// ./src/whitelabel/configs/hitech/index.js